import * as addressesActions from './../actions/addresses.actions';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { AddressesApiService } from 'app/services/addresses-api.service';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class AdressesEffects {
  constructor(
    private actions$: Actions,
    private addressesApi: AddressesApiService
  ) {}

  loadAddresses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addressesActions.loadAddresses),
      switchMap(({ loadOptions }) =>
        this.addressesApi.get(loadOptions).pipe(
          map((response) =>
            addressesActions.loadAddressesSuccess({ response })
          ),
          catchError((error) =>
            of(addressesActions.loadAddressesFailed({ error }))
          )
        )
      )
    )
  );

  createAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addressesActions.createAddress),
      switchMap(({ address }) =>
        this.addressesApi.create(address).pipe(
          map((addressResponse) =>
            addressesActions.createAddressSuccess({ address: addressResponse })
          ),
          catchError((error) =>
            of(addressesActions.createAddressFailed({ error }))
          )
        )
      )
    )
  );

  updateAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addressesActions.updateAddress),
      switchMap(({ address }) =>
        this.addressesApi.update(address).pipe(
          map((addressResponse) =>
            addressesActions.updateAddressSuccess({ address: addressResponse })
          ),
          catchError((error) =>
            of(addressesActions.updateAddressFailed({ error }))
          )
        )
      )
    )
  );

  deleteAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addressesActions.deleteAddress),
      switchMap(({ address }) => {
        return this.addressesApi.delete(address).pipe(
          switchMap(() => [
            addressesActions.deleteAddressSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_address_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(addressesActions.deleteAddressFailed({ error }))
          )
        );
      })
    )
  );

  loadAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addressesActions.loadAddress),
      switchMap(({ addressId }) =>
        this.addressesApi.load(addressId).pipe(
          map((address) => addressesActions.loadAddressSuccess({ address })),
          catchError((error) =>
            of(addressesActions.loadAddressFailed({ error }))
          )
        )
      )
    )
  );
}
